import { createRouter, createWebHistory } from 'vue-router';

import store from "@/store.js"

import Login from '@/views/Login.vue';
import Profile from '@/views/Profile.vue';
import CreateCalculationTemplate from '@/views/CreateCalculationTemplate.vue';
import EditCalculationTemplate from '@/views/EditCalculationTemplate.vue';
import CreateCalculation from '@/views/CreateCalculation.vue';
import Templates from "@/views/Templates.vue";
import Calculations from "@/views/Calculations.vue";
import Calculation from "@/views/Calculation.vue";
import CalculationEdit from "@/views/CalculationEdit.vue";
import Products from "@/views/Products.vue";
import Product from "@/views/Product.vue";
import ProductCreate from "@/views/ProductCreate.vue";
import Blocks from "@/views/Blocks.vue";
import Block from "@/views/Block.vue";
import BlockCreate from "@/views/BlockCreate.vue";

const routes = [
    {
        path: '/',
        name: 'login',
        component: Login,
        meta: {
            title: "titles.login",
            navbar: false,
        }
    },
    {
        path: '/logout/',
        name: 'logout',
        async beforeEnter(to, from, next) {
            // after logout redirect to login
            await store.getters.api.get("/auth/logout");
            store.commit("saveUserProfile", {});
            next({ name: "login" });
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {
            title: "titles.profile",
            navbar: true,
        }
    },
    {
        path: '/calculation/templates',
        name: 'templates',
        component: Templates,
        meta: {
            title: "titles.templates",
            navbar: true,
        }
    },
    {
        path: '/calculation/template/:id',
        name: 'templateEdit',
        component: EditCalculationTemplate,
        meta: {
            title: "titles.templateEdit",
            navbar: true,
        }
    },
    {
        path: '/calculations',
        name: 'calculations',
        component: Calculations,
        meta: {
            title: "titles.calculations",
            navbar: true,
        }
    },
    {
        path: '/calculation/template/create',
        name: 'createCalculationTemplate',
        component: CreateCalculationTemplate,
        meta: {
            title: "titles.createTemplate",
            navbar: true,
        }
    },
    {
        path: '/calculation/:id/create',
        name: 'createCalculation',
        component: CreateCalculation,
        meta: {
            title: "titles.createCalculation",
            navbar: true,
        }
    },
    {
        path: '/calculation/:slug',
        name: 'calculation',
        component: Calculation,
        meta: {
            title: "titles.calculation",
            navbar: true,
        }
    },
    {
        path: '/calculation/:slug/edit',
        name: 'calculationEdit',
        component: CalculationEdit,
        meta: {
            title: "titles.calculationEdit",
            navbar: true,
        }
    },
    {
        path: '/products',
        name: 'products',
        component: Products,
        meta: {
            title: "titles.products",
            navbar: true,
        }
    },
    {
        path: '/product/create',
        name: 'createProduct',
        component: ProductCreate,
        meta: {
            title: "titles.product",
            navbar: true,
        }
    },
    {
        path: '/product/:id',
        name: 'product',
        component: Product,
        meta: {
            title: "titles.product",
            navbar: true,
        }
    },
    {
        path: '/blocks',
        name: 'blocks',
        component: Blocks,
        meta: {
            title: "titles.blocks",
            navbar: true,
        }
    },
    {
        path: '/block/create',
        name: 'createBlock',
        component: BlockCreate,
        meta: {
            title: "titles.block",
            navbar: true,
        }
    },
    {
        path: '/block/:id',
        name: 'block',
        component: Block,
        meta: {
            title: "titles.block",
            navbar: true,
        }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes: routes
})

router.beforeEach((to, from, next) => {
    if (store.getters.isLoggedIn || to.name == 'login' || to.name == 'logout') {
        next();
    } else {
        next({ name: 'login', query: { path: to.path } });
    }
})

export default router;